import './footer.css'
import data from './data'

const Footer = () => {
  const getCurrentYear = () => { return new Date().getFullYear();};
  return (
   <section id='footer'>
    <h3>Partner with us</h3>
      <div className='social__container'>
      
      {
       
            data.map(item => <div key={item.id} className="social__icon">
                       
                   <a href={item.url} target='_blank' className='link' rel = "noopener noreferrer">
                   <i className='icon'>{item.icon}</i> 
                      <i className='title'>{item.title}</i> 
                   </a>
                      
            </div>)

          } 
         </div>
    <footer>&#169;  Copyright DViews 360 Photo & Video Booth, {getCurrentYear()}   </footer>
   </section>
  )
}

export default Footer